import * as React from 'react';
import type { GridToolbarProps } from './GridToolbar';

/**
 * GridToolbar is a sub component of datagrid.
 *
 * > ⚠️ *Warning*: This is a React.lazy component that must be wrapped with `React.Suspense`.
 */
export const GridToolbarLazy = React.lazy<
  React.ComponentType<GridToolbarProps>
>(() =>
  import('src/browser.data_grid_pro').then((module) => ({
    default: module.GridToolbar,
  }))
);
